/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

/**
 * Takes a number and returns a formatted US dollar string.
 * @param {number | string} rawVal A US dollar amount.
 * @returns {string} Formatted US dollar string.
 * @example
 *
 * formatAsDollars(1579)
 * -> '$1,578.00'
 */
export default function formatAsDollars(rawVal) {
  const numberVal = Number(rawVal);
  if (!_.isNaN(numberVal)) {
    const isNegative = numberVal < 0;
    const absVal = Math.abs(numberVal);
    // eslint-disable-next-line prefer-template
    const result = '$' + absVal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    if (isNegative) {
      return `-${result}`;
    }
    return result;
  }
}
